import { createFileRoute, redirect } from '@tanstack/react-router';
import { RecipeEditorPage } from '@/features/recipes/editor/recipe-editor';
import { meQuery } from '@/lib/auth/session';
import { followUserLocale } from '@/lib/i18n';

// S16 · Recipe editor (07 §4): a full page of its own, outside the shell, as
// its board draws it; still behind the session.
export const Route = createFileRoute('/carriers/$code/recipes/$version/edit')({
  beforeLoad: async ({ context, location }) => {
    const user = await context.queryClient.ensureQueryData(meQuery);
    if (!user) throw redirect({ to: '/login', search: { redirect: location.href } });
    // Outside the shell, so the person's language is applied here too.
    followUserLocale(user.locale);
    return { user };
  },
  component: EditorRoute,
});

function EditorRoute() {
  const { code, version } = Route.useParams();
  return <RecipeEditorPage code={code.toUpperCase()} version={Number(version)} />;
}
